/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type ReactNode } from 'react';
import { BreadcrumbContainer } from '../controller/index.tsx';

export type ManagerProps = {
	children: ReactNode;
};

export const BreadcrumbManager = ({ children }: ManagerProps): React.JSX.Element => (
	<BreadcrumbContainer>{children}</BreadcrumbContainer>
);
